import React from 'react';
import Button from '../Button';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import history from '../../history';
import { Select } from 'antd';
import Icon from '../../components/Icon';

const isMobile = window.innerWidth <= 845;

const TabNavigationContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;

  > a:not(:last-child) {
    margin-right: 16px;
  }

  > a {
    flex: 1;
    height: 60px;
    text-decoration: none;
  }

  .isRoute {
    background-color: black;
  }

  .buttonTabNav {
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      flex-direction: row;
      justify-content: center;

      .iconButtonContainer {
        margin: 0 16px;
      }

      span {
        padding: 0 16px;
      }
    }
  }

  .buttonTabNav svg {
    font-size: 10px;
  }

  span {
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      font-size: 16px;
      max-width: 75%;
    }
  }

  .navButtonDisabled:hover {
    cursor: not-allowed;
  }

  .selectTabNav {
    height: 60px;
    width: 100%;
  }

  a {
    color: white;
  }

  .ant-select .ant-select-selection-item {
    font-family: ${(props) => props.theme.fonts.oswald_semibold};
    color: white !important;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    background-color: #2b3d54;
    border-radius: 4px;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0 16px;
  }

  .ant-select .ant-select-arrow {
    width: 22px;
    height: 22px;
    justify-content: center;
    background: #141d26;
    border-radius: 50%;
    top: 41%;
  }

  .ant-select .ant-select-arrow .icon {
    color: white;
    font-size: 12px;
  }

  .navButtonMobile {
    color: white !important;
  }
`;

const TabNavigation = ({ buttons }) => {
  return (
    <TabNavigationContainer onClick={() => window.scrollTo(0, 0)}>
      {!isMobile ? (
        buttons.map((button) =>
          history.location.pathname === button.route ? (
            <NavLink
              key={button.label}
              to={button.route ? button.route : '/distribution'}
            >
              <Button
                label={button.label}
                fontFamily={'OswaldSemiBold'}
                color="dark"
                width="100%"
                height="60px"
                icon="dropdown"
                letterSpacing="1px"
                iconContainerColor="black"
                className="buttonTabNav"
              />
            </NavLink>
          ) : (
            <NavLink
              key={button.label}
              to={
                !button.disabled && button.route
                  ? button.route
                  : history.location.pathname
              }
            >
              <Button
                key={button.label}
                textTransform="uppercase"
                fontWeight={500}
                label={button.label}
                fontFamily={'Oswald'}
                width="100%"
                height="60px"
                color="white"
                textColor="grey-four"
                className={button.disabled && 'navButtonDisabled'}
              />
            </NavLink>
          )
        )
      ) : (
        <Select
          value={history.location.pathname}
          className="selectTabNav"
          options={buttons.map((button) => ({
            value: button.route,
            label: button.label.toUpperCase()
          }))}
          optionRender={(option) => (
            <NavLink key={option.label} to={option.value}>
              <div className="navButtonMobile">
                {option.label.toUpperCase()}
              </div>
            </NavLink>
          )}
          suffixIcon={<Icon icon={'dropdown'} />}
        />
      )}
    </TabNavigationContainer>
  );
};

export default TabNavigation;
